export default function Privacy() {
  return (
    <div className="min-h-screen bg-white pt-24" data-testid="privacy-page">
      {/* Hero Section */}
      <section className="py-16 md:py-20 bg-[#ECFDF5]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-3xl">
            <span className="text-[#10B981] text-sm font-semibold uppercase tracking-wider mb-4 block">Protection des données</span>
            <h1 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] leading-tight mb-6" data-testid="privacy-title">
              Politique de <span className="text-[#10B981]">confidentialité</span>
            </h1>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20" data-testid="privacy-content-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-4xl">
            <div className="bg-[#ECFDF5] border border-gray-100 rounded-3xl p-8 md:p-12 space-y-12">
              {/* Introduction */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">1. Introduction</h2>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed">
                  La présente politique de confidentialité a pour objectif d'informer les utilisateurs du site 0to1 sur la manière dont leurs données personnelles sont collectées, traitées et protégées, conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.
                </p>
              </div>

              {/* Responsable du traitement */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">2. Responsable du traitement</h2>
                <div className="text-[#1E3A5F] font-semibold space-y-2">
                  <p><strong className="text-[#1A1A1A]">Raison sociale :</strong> 0to1</p>
                  <p><strong className="text-[#1A1A1A]">Responsable :</strong> Jehan Druguet</p>
                  <p><strong className="text-[#1A1A1A]">Email :</strong> jehan@0to1-agency.fr</p>
                  <p><strong className="text-[#1A1A1A]">Téléphone :</strong> 06 58 93 05 95</p>
                </div>
              </div>

              {/* Données collectées */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">3. Données collectées</h2>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed mb-4">
                  Dans le cadre de l'utilisation de notre site, nous sommes susceptibles de collecter les données suivantes :
                </p>
                <ul className="text-[#1E3A5F] font-semibold space-y-2 list-disc list-inside">
                  <li>Nom et prénom</li>
                  <li>Adresse email</li>
                  <li>Numéro de téléphone</li>
                  <li>Informations relatives à votre entreprise</li>
                  <li>Toute information transmise via le formulaire de contact</li>
                </ul>
              </div>

              {/* Finalités du traitement */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">4. Finalités du traitement</h2>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed mb-4">
                  Les données personnelles collectées sont utilisées pour :
                </p>
                <ul className="text-[#1E3A5F] font-semibold space-y-2 list-disc list-inside">
                  <li>Répondre à vos demandes de contact et de renseignements</li>
                  <li>Vous proposer nos services commerciaux</li>
                  <li>Établir des devis et contrats</li>
                  <li>Assurer le suivi de la relation commerciale</li>
                  <li>Améliorer nos services et votre expérience utilisateur</li>
                </ul>
              </div>

              {/* Base légale */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">5. Base légale du traitement</h2>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed">
                  Le traitement de vos données personnelles est fondé sur votre consentement explicite lors de la soumission du formulaire de contact, ainsi que sur l'exécution de mesures précontractuelles ou contractuelles.
                </p>
              </div>

              {/* Destinataires des données */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">6. Destinataires des données</h2>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed">
                  Vos données personnelles sont destinées uniquement à 0to1 et ne sont en aucun cas cédées, vendues ou louées à des tiers. Seuls les collaborateurs habilités de 0to1 ont accès à ces données dans le cadre de leurs fonctions.
                </p>
              </div>

              {/* Durée de conservation */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">7. Durée de conservation</h2>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed">
                  Vos données personnelles sont conservées pendant une durée de 3 ans à compter du dernier contact avec vous. Au-delà de cette période, vos données seront supprimées ou anonymisées.
                </p>
              </div>

              {/* Vos droits */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">8. Vos droits</h2>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed mb-4">
                  Conformément au RGPD, vous disposez des droits suivants concernant vos données personnelles :
                </p>
                <ul className="text-[#1E3A5F] font-semibold space-y-2 list-disc list-inside">
                  <li><strong className="text-[#1A1A1A]">Droit d'accès :</strong> obtenir la confirmation que des données vous concernant sont traitées et en obtenir une copie</li>
                  <li><strong className="text-[#1A1A1A]">Droit de rectification :</strong> demander la correction de données inexactes ou incomplètes</li>
                  <li><strong className="text-[#1A1A1A]">Droit à l'effacement :</strong> demander la suppression de vos données</li>
                  <li><strong className="text-[#1A1A1A]">Droit à la limitation :</strong> demander la limitation du traitement de vos données</li>
                  <li><strong className="text-[#1A1A1A]">Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
                  <li><strong className="text-[#1A1A1A]">Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
                </ul>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed mt-4">
                  Pour exercer ces droits, vous pouvez nous contacter à : <a href="mailto:jehan@0to1-agency.fr" className="text-[#10B981] hover:underline">jehan@0to1-agency.fr</a>
                </p>
              </div>

              {/* Sécurité */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">9. Sécurité des données</h2>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed">
                  0to1 met en œuvre toutes les mesures techniques et organisationnelles appropriées pour garantir la sécurité et la confidentialité de vos données personnelles, notamment contre tout accès non autorisé, perte, destruction ou altération.
                </p>
              </div>

              {/* Cookies */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">10. Cookies</h2>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed">
                  Notre site utilise uniquement des cookies techniques nécessaires à son bon fonctionnement. Ces cookies ne collectent aucune donnée personnelle à des fins publicitaires ou de profilage.
                </p>
              </div>

              {/* Modification */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">11. Modification de la politique</h2>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed">
                  0to1 se réserve le droit de modifier la présente politique de confidentialité à tout moment. Toute modification sera publiée sur cette page avec une date de mise à jour.
                </p>
              </div>

              {/* Réclamation */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">12. Réclamation</h2>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed">
                  Si vous estimez que le traitement de vos données personnelles constitue une violation du RGPD, vous avez le droit d'introduire une réclamation auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés) : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#10B981] hover:underline">www.cnil.fr</a>
                </p>
              </div>

              {/* Date de mise à jour */}
              <div className="pt-8 border-t border-gray-200">
                <p className="text-[#9CA3AF] text-sm">
                  Dernière mise à jour : Janvier 2026
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
